<script lang="ts">
  import UserCircleIcon from "virtual:icons/heroicons/user-circle-solid";
  import ArrowPathIcon from "virtual:icons/heroicons/arrow-path";
  import GlobeIcon from "virtual:icons/heroicons/globe-alt";
  import ShieldCheckIcon from "virtual:icons/heroicons/shield-check";
  import BanknotesIcon from "virtual:icons/heroicons/banknotes-solid";
  import { getLocalizedUrl } from "$lib/i18n";
  import { page } from "$app/stores";
  import { getI18nContext } from "$lib/i18n.svelte";

  const { locale } = $page.data;
  const t = getI18nContext().getFixedT(null, "features");
</script>

<section class="relative bg-blue-50 flex flex-col" id="features">
  <div class="mx-auto px-4 md:px-8 lg:px-26 py-16 max-w-5xl">
    <div class="text-center mb-16">
      <h2 class="font-bold tracking-wide uppercase text-blue-700">
        {t("page.title")}
      </h2>
      <p class="text-gray-700 text-xl mt-6">
        {@html t("page.subtitle")}
      </p>
    </div>

    <div class="mx-auto gap-8 grid md:gap-y-12 sm:grid-cols-2">
      <aside class="feature">
        <div class="feature__logo">
          <UserCircleIcon class="feature__logo__svg" />
        </div>
        <div>
          <h3>
            {t("list.account.title")}
          </h3>
          <p>
            {t("list.account.description")}
          </p>
        </div>
      </aside>

      <aside class="feature">
        <div class="feature__logo">
          <ArrowPathIcon class="feature__logo__svg" />
        </div>
        <div>
          <h3>
            {t("list.subscription.title")}
          </h3>
          <p>
            {@html t("list.subscription.description")}
          </p>
        </div>
      </aside>

      <aside class="feature">
        <div class="feature__logo">
          <GlobeIcon class="feature__logo__svg" />
        </div>
        <div>
          <h3>
            {t("list.global.title")}
          </h3>
          <p>
            {t("list.global.description")}
            <a href={getLocalizedUrl(locale, "/availability")}><sup>1</sup></a>
          </p>
        </div>
      </aside>

      <aside class="feature">
        <div class="feature__logo">
          <ShieldCheckIcon class="feature__logo__svg" />
        </div>
        <div>
          <h3>
            {t("list.secure.title")}
          </h3>
          <p>
            {t("list.secure.description")}
          </p>
        </div>
      </aside>

      <aside class="feature">
        <div class="feature__logo">
          <BanknotesIcon class="feature__logo__svg" />
        </div>
        <div>
          <h3>
            {t("list.payment.title")}
          </h3>
          <p>
            {@html t("list.payment.description")}
          </p>
        </div>
      </aside>
    </div>
  </div>
</section>

<style lang="postcss">
  aside.feature {
    @apply flex flex-row max-w-md;
  }

  div.feature__logo {
    @apply flex justify-center;
  }

  :global(.feature__logo__svg) {
    @apply mr-4 bg-blue-600 fill-white text-white p-2 h-10 w-10 rounded-full;
  }

  aside.feature h3 {
    @apply font-bold text-xl;
  }

  aside.feature p {
    @apply text-gray-600 mt-3;
  }
</style>
